<template>
  <div class="app min-h-screen  text-white text-center px-4 py-10">
    <idioma />
    <div class="flex-1 flex flex-col justify-center items-center">
      <slot />
    </div>
    <footer-base />
  </div>
</template>

<script>
import Idioma from './Idioma.vue'
import FooterBase from './FooterBase.vue'

export default {
  name: 'ErrorLayout',
  components: {
    Idioma,
    FooterBase
  }
}
</script>

<style lang="scss" scoped>
.app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 20px auto;
  max-width: 400px;
  padding: 12px;
  font-size: 14px;
  user-select: none;
}
</style>